<template>
  <div class="container">
    <div class="handle-wrapper">
      <div class="handle-left">
        <Input
          v-model="searchSalesText"
          search
          placeholder="搜索销售项目..."
          @on-change="searchSales"
          clearable
          icon="ios-search"
          style="width: 230px; margin-right: 20px"
        ></Input>
        <Input
          v-model="searchCusText"
          search
          placeholder="搜索客户..."
          @on-change="searchCustomer"
          clearable
          icon="ios-search"
          style="width: 230px; margin-right: 20px"
        ></Input>
      </div>
      <div class="handle-right">
        <div class="page-wrap">
          <span>共{{ totalCounts }}条</span>
          <Page
            :total="Number(totalCounts)"
            :page-size="limit"
            @on-change="loadSalesOrderTablePage"
            show-total
            simple
            style="min-width: 160px"
          />
        </div>
      </div>
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table
        :columns="columns"
        :height="tableHeight"
        :loading="tableLoading"
        :data="salesOrderList"
        border
      >

      </Table>
    </div>
    <SODrawer ref="SODrawer" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import dayjs from "dayjs";
import SODrawer from "../SalesOrderPage/SODrawer.vue";

const returnTypeToText = {
  full: "打不下",
  quality: "质量问题",
  others: "其它"
};

export default {
  components: {
    SODrawer,
  },
  name: 'SalesOrderTablePage',
  data() {
    return {
      tableHeight: 300,
      searchSalesText: null,
      searchCusText: null,
      limit: 20,
      page: 0,
      filterQuery: {},
      tableLoading: false,
      columns: [
        {
          title: "销售项目",
          key: "sales",
          fixed: "left",
          width: 250,
          render: (h, params) => {
            return h(
              "span",
              {
                style: { cursor: "pointer", color: "#42b983" },
                on: {
                  click: () => {
                    this.$refs.SODrawer.openDrawer(params.row);
                  },
                },
              },
              params.row.sales.abbr
            );
          },
        },
        {
          title: "工厂",
          key: "factory",
          fixed: "left",
          width: 100,
          render: (h, params) => {
            return h(
              "span",
              params.row.factory.name
            );
          },
        },
        {
          title: "公司",
          key: "company",
          fixed: "left",
          width: 120,
          render: (h, params) => {
            return h(
              "span",
              params.row.company.abbr || params.row.company.name
            );
          },
        },
        {
          title: "产品型号",
          key: "company",
          fixed: "left",
          width: 120,
          render: (h, params) => {
            return h(
              "span",
              params.row.material?.model
            );
          },
        },
        {
          title: "配方",
          minWidth: 120,
          key: "recipe",
          render: (h, params) =>
            h(
              "span",
              "#" +
                params.row.recipe?.NoId +
                "(" +
                params.row.recipe?.name +
                ")"
            )
        },
        {
          title: "吨数",
          key: "volPlan",
          maxWidth: 70,
          minWidth: 60,
          align: "right",
          sortable: true
        },
        {
          title: "需求时间",
          key: "orderedBy",
          maxWidth: 120,
          minWidth: 100,
          align: "right",
          render: (h, params) =>
            h("span", dayjs(params.row.planArrivedAt).format("YYYY/M/D H:mm"))
        },
        {
          title: "车辆",
          key: "vehicle",
          maxWidth: 90,
          minWidth: 90,
          render: (h, params) => {
            if (params.row.delivery && params.row.delivery.vehicle)
              return h(
                "span",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    cursor: "pointer"
                  },
                  // on: {
                  //   click: async () => {
                  //     this.createDeliveryInRow(params.row, "vehicle");
                  //   }
                  // }
                },
                params.row.delivery.vehicle.plate
              );
          }
        },
        {
          title: "司机",
          key: "driver",
          maxWidth: 90,
          minWidth: 90,
          render: (h, params) => {
            if (
              params.row.delivery &&
              params.row.delivery.vehicle &&
              params.row.delivery.driver
            ) {
              const str = params.row.delivery.driver
                .map(x => x.name)
                .join(", ");
              return h(
                "div",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    cursor: "pointer"
                  },
                  // on: {
                  //   click: async () =>
                  //     this.createDeliveryInRow(params.row, "driver")
                  // }
                },
                str
              );
            }
          }
        },
        {
          title: "备注",
          minWidth: 160,
          key: "remark"
        },
        {
          title: "实际抵达时间",
          width: 140,
          key: "orderedBy",
          render: (h, params) => {
            if (params.row.arrivedAt) {
              return h(
                "span",
                dayjs(params.row.arrivedAt).format("MM-DD HH:mm")
              );
            }
          }
        },
        {
          title: "退货类型",
          minWidth: 110,
          key: "orderedBy",
          render: (h, params) => {
            return h(
              "span",
              params.row.returnType
                ? returnTypeToText[params.row.returnType]
                : ""
            );
          }
        },
        {
          title: "退货数量（吨）",
          minWidth: 110,
          key: "orderedBy",
          align: "right",
          render: (h, params) => {
            return h("span", params.row.volReturn ? params.row.volReturn : "");
          }
        },
        {
          title: "退货原因",
          width: 140,
          key: "orderedBy",
          render: (h, params) => {
            return h(
              "span",
              params.row.returnReason ? params.row.returnReason : ""
            );
          }
        },
        {
          title: "创建人",
          key: "createdBy",
          maxWidth: 90,
          minWidth: 90,
          render: (h, params) => h("span", params.row.createdBy.name)
        },
        // {
        //   title: "操作",
        //   key: "操作",
        //   slot: "action",
        //   align: "center",
        //   fixed: "right",
        //   width: 140
        // }
        // {
        //   title: "材料成本",
        //   key: "materialCost",
        //   width: 100,
        //   align: "right",
        //   render: (h, params) => h("span", this.formatNumber(params.row.materialCost)),
        // },
        // {
        //   title: "复配加工费",
        //   key: "manufactCost",
        //   width: 100,
        //   align: "right",
        //   render: (h, params) => h("span", this.formatNumber(params.row.manufactCost)),
        // },
        // {
        //   title: "运费",
        //   key: "transCost",
        //   width: 100,
        //   align: "right",
        //   render: (h, params) => h("span", this.formatNumber(params.row.transCost)),
        // },
        // {
        //   title: "业务费",
        //   key: "promoFee",
        //   width: 100,
        //   align: "right",
        //   render: (h, params) => h("span", this.formatNumber(params.row.promoFee)),
        // },
        // {
        //   title: "管理费",
        //   key: "manageCost",
        //   width: 100,
        //   align: "right",
        //   render: (h, params) => h("span", this.formatNumber(params.row.manageCost)),
        // },
        // {
        //   title: "不含税成本",
        //   key: "totalCostBeforeTax",
        //   width: 100,
        //   align: "right",
        //   render: (h, params) => h("span", this.formatNumber(params.row.totalCostBeforeTax)),
        // },
        // {
        //   title: "税费",
        //   key: "tax",
        //   width: 100,
        //   align: "right",
        //   render: (h, params) => h("span", this.formatNumber(params.row.tax)),
        // },
        // {
        //   title: "总成本",
        //   key: "totalCost",
        //   width: 100,
        //   align: "right",
        //   render: (h, params) => h("span", this.formatNumber(params.row.totalCost)),
        // },
        // {
        //   title: "利润",
        //   key: "profit",
        //   width: 100,
        //   align: "right",
        //   render: (h, params) => h("span", this.formatNumber(params.row.profit)),
        // },
        // {
        //   title: "资金成本",
        //   key: "agingCost",
        //   width: 100,
        //   align: "right",
        //   render: (h, params) => h("span", this.formatNumber(params.row.agingCost)),
        // },
        // {
        //   title: "资后成本",
        //   key: "totalCostWithAging",
        //   width: 100,
        //   align: "right",
        //   render: (h, params) => h("span", this.formatNumber(params.row.totalCostWithAging)),
        // },
        // {
        //   title: "扣资利润",
        //   key: "profitAfterAging",
        //   width: 100,
        //   align: "right",
        //   render: (h, params) => h("span", this.formatNumber(params.row.profitAfterAging)),
        // },
      ],
    };
  },
  computed: mapState({
    salesOrderList: (state) => state.salesOrder.salesOrderList,
    totalCounts: (state) => state.salesOrder.totalCounts,
  }),
  methods: {
    ...mapActions({
      getSalesOrderTable: "salesOrder/getSalesOrderTableAction",
    }),
    async loadSalesOrderTablePage(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      if (this.searchSalesText) {
        this.filterQuery.sales_name = this.searchSalesText;
      } else {
        delete this.filterQuery.sales_name;
      }
      if (this.searchCusText) {
        this.filterQuery.cus_name = this.searchCusText;
      } else {
        delete this.filterQuery.cus_name;
      }
      try {
        this.tableLoading = true;
        await this.getSalesOrderTable(this.filterQuery)
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
        this.tableLoading = false;
      }
    },
    searchCustomer() {
      this.searchSalesText = null
      this.loadSalesOrderTablePage()
    },
    searchSales() {
      this.searchCusText = null
      this.loadSalesOrderTablePage()
    },
    formatNumber(v, type) {
      if (typeof v === 'number') {
        if (type === 'percent') {
          return (v * 100).toFixed(1) + '%'
        }
        return v.toLocaleString(undefined, {
          minimumFractionDigits: this.numberDigit,
          maximumFractionDigits: this.numberDigit,
        });
      } else {
        return '-'
      }
    },
  },
  created() {
    this.loadSalesOrderTablePage();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>
<style lang="stylus" scoped>
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

  .handle-left
    display flex
    align-items center

  .handle-right
    display flex
    align-items center

    .page-wrap
      display flex
      align-items center
      min-width 220px

.table-wrapper
  width 100%
  height calc(100% - 48px)
</style>